import { render, staticRenderFns } from "./moralAgreement.vue?vue&type=template&id=5be6b222&scoped=true&"
import script from "./moralAgreement.vue?vue&type=script&lang=js&"
export * from "./moralAgreement.vue?vue&type=script&lang=js&"
import style0 from "./moralAgreement.vue?vue&type=style&index=0&id=5be6b222&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be6b222",
  null
  
)

export default component.exports